import React, { useState, useRef } from 'react'
import Header from './Header'
import Topsection from './Topsection';
import Footer from './Footer';
import Faq from './Faq';
import { Link } from 'react-router-dom';
import Logoslider from './Logoslider'
import FloatingButton from './FloatingButton';
import Mobilefooterbtn from './Mobilefooterbtn';

const Java = () => {

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/assets/brochures/FSD Java with Angular.pdf';
    link.download = 'FSD Java with Angular.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <Topsection/>
      <Header/>
      <div className='bg-hero1'>
        <div className='container myfont1'>
          <div className='row animate__animated animate__slow animate__fadeInDown'>
            <div className='col-md-8 text-start mt-4'>
              <h2 className='coursetitle1 mb-4 fw-bold'>Full Stack Java Development</h2>
              <p className='fw-semibold'>
                  Explore the world of Full Stack Development with Java and unlock your potential. Enroll today to gain in-depth knowledge and hands-on experience from an expert in the field.
              </p>

              <div className='d-none d-sm-block'>
              <div className="row">
                <div className="col-md-4">
                  <div className="card text-center mb-2 w-100">
                    <div className="card-body">
                      <h6 className="card-title">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-calendar2-week" viewBox="0 4 16 10">
                          <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z"/>
                          <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5zM11 7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm-5 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z"/>
                        </svg>&nbsp;<span className='fw-bold'>Course Duration:</span>
                      </h6>
                      <p className="card-text">5 Months</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card text-center mb-2">
                    <div className="card-body">
                      <h6 className="card-title">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-backpack" viewBox="0 0 16 16">
                          <path d="M4.04 7.43a4 4 0 0 1 7.92 0 .5.5 0 1 1-.99.14 3 3 0 0 0-5.94 0 .5.5 0 1 1-.99-.14M4 9.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5zm1 .5v3h6v-3h-1v.5a.5.5 0 0 1-1 0V10z"/>
                          <path d="M6 2.341V2a2 2 0 1 1 4 0v.341c2.33.824 4 3.047 4 5.659v5.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 13.5V8a6 6 0 0 1 4-5.659M7 2v.083a6 6 0 0 1 2 0V2a1 1 0 0 0-2 0m1 1a5 5 0 0 0-5 5v5.5A1.5 1.5 0 0 0 4.5 15h7a1.5 1.5 0 0 0 1.5-1.5V8a5 5 0 0 0-5-5"/>
                        </svg>&nbsp;<span className='fw-bold'>Mode Of Training:</span>
                      </h6>
                      <p className="card-text">Classroom & Online</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card text-center mb-2">
                    <div className="card-body">
                      <h6 className="card-title">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-journal" viewBox="0 0 16 16">
                          <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2"/>
                          <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z"/>
                        </svg>&nbsp;<span className='fw-bold'>Case Studies:</span>
                      </h6>
                      <p className="card-text">20+</p>
                    </div>
                  </div>
                </div>
              </div>
              </div>

              <div className='d-block d-sm-none'>
                <div className="mt-4 d-flex justify-content-center align-items-center flex-column">
                  <ul className="list-unstyled text-start">
                    <li><i className="bi bi-check-circle"></i>&nbsp;&nbsp;<strong className='fs-5'>Course Duration:</strong> 5 Months</li>
                    <li><i className="bi bi-check-circle"></i>&nbsp;&nbsp;<strong className='fs-5'>Mode Of Training:</strong> Classroom & Online</li>
                    <li><i className="bi bi-check-circle"></i>&nbsp;&nbsp;<strong className='fs-5'>Case Studies:</strong> 20+</li>
                  </ul>
                </div>
              </div>

              <br/>
              {/* <button className="btn btn-outline-light mb-3 me-2 px-4 py-2 fw-semibold shadow-sm" type="button">Download Brochure</button>
              <Link className="btn btn-outline-light mb-3 px-4 py-2 fw-semibold shadow-sm" to="/batchschedule">Free Demo Session Available</Link> */}

              <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 py-2">
                <button className="btn btn-outline-light px-4 py-2 fw-semibold shadow-sm" type="button" data-bs-toggle="modal" data-bs-target="#whatsappModal">
                  Download Brochure
                </button>
                <Link className="btn btn-outline-light px-4 py-2 fw-semibold shadow-sm" to="/batchschedule">
                  Free Demo Session Available
                </Link>
              </div>


            </div>
            <div className='col-md-4'>

              <div className='container mt-4 mb-4 bg-white rounded myfont1'>
                <h3 className='text-white pt-2 pb-2 bg-primary myborderbottom fw-bold'>Enquire Now</h3>
                <form className="p-4">
                  <div className='form-group text-start'>
                    <input type="text" placeholder='Enter your name' className='form-control mb-2 rounded-0'/>
                  </div>

                  <div className='form-group text-start'>
                    <input type="email" placeholder='Enter your email' className='form-control mb-2 rounded-0'/>
                  </div>

                  <div className='form-group text-start'>
                    <input type="number" placeholder='Enter your contact' className='form-control mb-4 rounded-0'/>
                  </div>
                  
                  <div className="d-grid pb-3 mb-2">
                    <button className="btn btn-primary fw-bold" type="button">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    {/* Course Content */}
    <div className='container myfont1'>
      <div className='row'>
        <div className='col-md-8 text-start mt-4'>
          <h2 className='text-center mt-2 mb-4 fw-bold'>Course Content</h2>

            <div className="accordion" id="accordionCourses">
              {/* collapseOne */}
              <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="headingOne">
                  <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button"
                    data-bs-toggle="collapse" data-bs-target="#collapseOne"
                    aria-expanded="false" aria-controls="collapseOne">
                    C Language, Logic Building, Data Structures and Algorithms
                    <span className="toggle-icon ms-auto"></span>
                  </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionCourses">
                  <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>C language</strong>:
                    <ul>
                      <li>History & Introduction of C language</li>
                      <li>Installation of C</li>
                      <li>Introduction to First Program</li>
                      <li>Variables & Datatypes</li>
                      <li>Control Statements, Break, Continue, Goto</li>
                      <li>Working with Functions</li>
                      <li>C Math Functions, Enumeration ( enum )</li>
                      <li>Working with Arrays</li>
                      <li>Pointers</li>
                      <li>Strings</li>
                      <li>Structure & Union</li>
                      <li>File Handling</li>
                      <li>Internal Theory & Practical Exam</li>
                    </ul>

                    <strong>C-Logic Building</strong>:
                    <ul>
                      <li>Introduction to C and Basic I/O</li>
                      <li>Data Types, Operators, and Expressions</li>
                      <li>Conditional Statements (If-Else, Switch)</li>
                      <li>Loops (For, While, Do-While)</li>
                      <li>Nested Loops and Pattern Printing</li>
                      <li>Functions and Recursion</li>
                      <li>Arrays (1D, 2D, Multi)</li>
                      <li>Strings and String Manipulation</li>
                      <li>Structures and Unions</li>
                      <li>File Handling in C</li>
                      <li>Advanced Logic Problems</li>
                      <li>Mini Project (Choose One</li>
                    </ul>

                    <strong>Data Structures & Algorithms</strong>:
                    <ul>
                      <li>Introduction to Data Structures & Complexity Analysis</li>
                      <li>Arrays and Pointer Basics</li>
                      <li>Multi-Dimensional Arrays & Matrix Operations</li>
                      <li>String Manipulation in C</li>
                      <li>Searching Algorithms</li>
                      <li>Sorting Algorithms (Part 1)</li>
                      <li>Sorting Algorithms (Part 2)</li>
                      <li>Introduction to Linked Lists</li>
                      <li>Doubly and Circular Linked Lists</li>
                      <li>Stack Data Structure</li>
                      <li>Queue Data Structure</li>
                      <li>Priority Queue & Deque</li>
                      <li>Introduction to Trees</li>
                      <li>Binary Search Tree (BST)</li>
                      <li>Balanced Trees & Heaps</li>
                      <li>Introduction to Graphs & Representations</li>
                      <li>Shortest Path Algorithms</li>
                      <li>Hashing and Hash Tables</li>
                      <li>Dynamic Programming Concepts</li>
                      <li>Final Project & Optimization Techniques</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* collapseTwo */}
              <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="headingTwo">
                  <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button"
                    data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                    aria-expanded="false" aria-controls="collapseTwo">
                    SQL, PL-SQL
                    <span className="toggle-icon ms-auto"></span>
                  </button>
                </h2>
                <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionCourses">
                  <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                      <li>Introduction to SQL</li>
                      <li>Installation of SQL setup</li>
                      <li>SQL Table - Create, Drop, Alter, etc.</li>
                      <li>SQL operations on select, Clause, Order By, Insert, Delete, Update, etc. queries</li>
                      <li>SQL Joins, Keys, Indexes</li>
                      <li>SQL - Sub Queries</li>
                      <li>Normalization - 1NF, 2NF, 3NF, etc.</li>
                      <li>PL SQL - Control Statements, Triggers, Functions, Stored Procedures</li>
                      <li>Indexing - Clustered, Non-Clustered, etc.</li>
                      <li>Cursor</li>
                      <li>Internal Theory & Practical Exam</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* collapseThree */}
              <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="headingThree">
                  <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button"
                    data-bs-toggle="collapse" data-bs-target="#collapseThree"
                    aria-expanded="false" aria-controls="collapseThree">
                    Frontend
                    <span className="toggle-icon ms-auto"></span>
                  </button>
                </h2>
                <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionCourses">
                  <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>HTML 5 (Hyper Text Markup Language)</strong>:
                    <ul>
                      <li>Introduction to HTML and their versions</li>
                      <li>Tags and their attributes</li>
                      <li>Advance HTML tags like forms, frames, tables,etc.</li>
                      <li>Basic Webpage & Website design</li>
                      <li>Internal Theory & Practical Exam</li>
                    </ul>

                    <strong>CSS3 (Cascading Style Sheet)</strong>:
                    <ul>
                      <li>Introduction to CSS and Their versions</li>
                      <li>Types of Style Sheets</li>
                      <li>CSS Properties</li>
                      <li>CSS Selectors</li>
                      <li>Absolute and Relative positioning, DIV + CSS</li>
                      <li>CSS Gradient & Layouts</li>
                      <li>Internal Theory & Practical Exam</li>
                    </ul>

                    <strong>Bootstrap</strong>:
                    <ul>
                      <li>Bootstrap - Home, Overview, Environment Setup</li>
                      <li>Bootstrap - Grid System, CSS Overview, Typography, code, Tables, Forms, Buttons images</li>
                      <li>Bootstrap - Responsive utilities</li>
                      <li>Bootstrap Plugins, Plugins Overview, Transition Plugin, Modal Plugin, Dropdown plugin, Scrollspy Plugin, -Tab Plugin, Tooltip Plugin, Popover Plugin, Alert Plugin, </li>
                      <li>Button Plugin, Collapse Plugin</li>
                      <li>Flex</li>
                      <li>Bootstrap Demos ( Practice Sessions )</li>
                      <li>Internal Theory & Practical Exam</li>
                    </ul>

                    <strong>JavaScript</strong>:
                    <ul>
                      <li>Introduction to Scripting & javascript</li>
                      <li>Javascript variables & operators.</li>
                      <li>Javascript Looping statements, Events & Functions, DOM & BOM</li>
                      <li>JS Popup Boxes</li>
                      <li>Internal Theory & Practical Exam</li>
                    </ul>

                    <strong>Jquery</strong>:
                    <ul>
                      <li>Jquery overview, Basics, Selectors, Attributes</li>
                      <li>JQuery traversing</li>
                      <li>JQuery effects, Jquery events</li>
                      <li>JQuery HTML / CSS, Jquery forms</li>
                      <li>JQuery Ajax, JQuery UI</li>
                    </ul>

                    <strong>Portfolio Designing Task</strong>
                  </div>
                </div>
              </div>

              {/* collapseFour */}
              <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="headingFour">
                  <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button"
                    data-bs-toggle="collapse" data-bs-target="#collapseFour"
                    aria-expanded="false" aria-controls="collapseFour">
                    Core Java
                    <span className="toggle-icon ms-auto"></span>
                  </button>
                </h2>
                <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionCourses">
                  <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                      <li>Getting started - What is JAVA? Java Language Environment, Introduction to java language, JVM and its working, Features of java language, Difference between JDK, JRE and JVM</li>
                      <li>Basic Language Constructs - Data types, Operators in java, Conditional construct, Looping construct, Arrays, Scanner Class</li>
                      <li>OOP’s Concepts, OOP’s Features</li>
                      <li>Major Pillars of JAVA - Encapsulation, Abstraction, Inheritance, Polymorphism Creating classes and Objects - Declaring variable and accessing it. Types of Objects & Garbage Collection</li>
                      <li>Methods, Constructors, Use of Access Specifiers, static and This keyword</li>
                      <li>Inheritance- Type of inheritance, Concept of Polymorphism, Method Overloading, Method Overriding, Super Keyword.</li>
                      <li>Polymorphism- Final Keyword, Runtime Polymorphism, Abstract Classes, Interfaces</li>
                      <li>Packages, import and static import</li>
                      <li>String, Immutable String Comparison, String Concatenation, Substring, Methods of String class, StringBuffer class, StringBuilder class, String vs StringBuffer vs StringBuilder toString method.</li>
                      <li>Exception Handling - What is Exception, Exception type & hierarchy, Handling Exception using try - catch, throw & throws, Custom Exception, Finally Block.</li>
                      <li>Multithreading - What is Multithreading, Life Cycle of a Thread, Creating Thread, Thread States, Method of Thread with Examples, Synchronization in Multithreading</li>
                      <li>Collection Framework : ArrayList, LinkedList, List Interface, HashSet. LinkedHashSet, TreeSet, & Map Interface, HashMap, LinkedHashMap, Hashtable, Comparable Interface, Comparator Interface, Comparable vs Comparator.</li>
                      <li>Java Serialization use of transient keyword.</li>
                      <li>Java I/O - FileOutputStream, FileInputStream, BufferedOutputStream, BufferedInputStream, FileWriter, FileReader, BufferedWriter, BufferedReader</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* collapseFive */}
              <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="headingFive">
                  <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button"
                    data-bs-toggle="collapse" data-bs-target="#collapseFive"
                    aria-expanded="false" aria-controls="collapseFive">
                    Advance Java
                    <span className="toggle-icon ms-auto"></span>
                  </button>
                </h2>
                <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionCourses">
                  <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>JDBC</strong>:
                    <ul>
                      <li>JDBC Introduction</li>
                      <li>JDBC DriverDB Connectivity, Steps Connectivity with StatementResultSet, PreparedStatement, ResultSetMetaData, DataBaseMetaDataStore</li>
                      <li>Operation like create, insert, update, delete, select, alter and from keyword values.</li>
                      <li>Stored procedure and its CallableStatement with examples.</li>
                    </ul>

                    <strong>Servlet & JSP</strong><br></br><br></br>

                    <strong>Spring</strong>:
                    <ul>
                      <li>What is Spring</li>
                      <li>IOC Container, Dependency Injection, Constructor Injection, CI Dependent Object, CI with Collection, CI with Map, Inheriting Bean Setter Injection.</li>
                      <li>SI Dependent Object, SI with Collection, Factory Method Spring Bean Autowiring Tutorial</li>
                      <li>Example On Spring Autowiring byName, Example On Spring Autowiring by Type, Example On Spring Autowiring by Constructor, Example On Spring Autowiring by Autodetect.</li>
                      <li>Spring AOP</li>
                      <li>AOP Concepts, Types of Advice with complete Explanation. Example On Spring AOP Before Advice, After Advice</li>
                      <li>Spring jdbc Template</li>
                      <li>Spring MVC</li>
                      <li>Spring MVC, Multiple ControllerRequest, Response, MVC Form</li>
                    </ul>

                    <strong>Hibernate</strong>:
                    <ul>
                      <li>HB Introduction</li>
                      <li>HB in Eclipse IDE</li>
                      <li>Hibernate Example, Hibernate - Annotations</li>
                      <li>Inheritance Mapping. Table Per Hierarchy. Table Per Hierarchy using Annotation.</li>
                      <li>Table Per Concrete, Table Per Concrete using Annotation.</li>
                      <li>Table Per Subclass, Table Per Subclass using Annotation</li>
                      <li>Collection Mapping</li>
                      <li>Component Mapping and Example</li>
                      <li>HQL : Hibernate query language and its Operation</li>
                      <li>Mapping - One to One, One to Many, Many to One, Many to Many Mapping</li>
                    </ul>

                    <strong>Spring Boot</strong>:
                    <ul>
                      <li>Spring Boot Introduction</li>
                      <li>Installation, Setup in eclipse</li>
                      <li>First Spring Boot Project - Hello World</li>
                      <li>Dispatcher Servlet</li>
                      <li>Dependency Injection</li>
                      <li>Autowiring</li>
                      <li>Spring Boot Application Properties</li>
                      <li>Client Server Mapping</li>
                      <li>@RequestParam Annotation</li>
                      <li>Spring Boot MVC - Model, View, Controller</li>
                      <li>Spring Boot CRUD Operations</li>
                      <li>JPA Custom queries with Query Method</li>
                      <li>Spring Boot Rest API</li>
                      <li>Spring Boot Rest API with Postman Tool</li>
                      <li>Spring Boot Security</li>
                      <li>Spring Boot - Thymeleaf</li>
                    </ul>

                    <strong>Micro Services</strong>:
                    <ul>
                      <li>Micro Services Introduction</li>
                      <li>Principle and Characteristics</li>
                      <li>Use Cases and Benefits</li>
                      <li>Challenges</li>
                      <li>Design Standards</li>
                      <li>Micro Services Communication</li>
                      <li>User Interfaces integration with Micro Services</li>
                    </ul>

                    <strong>REST API</strong>:
                    <ul>
                      <li>Introduction</li>
                      <li>Types – Private,Public, Partner</li>
                      <li>Serialization & Deserialization</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* collapseSix */}
              <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="headingSix">
                  <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button"
                    data-bs-toggle="collapse" data-bs-target="#collapseSix"
                    aria-expanded="false" aria-controls="collapseSix">
                    Angular
                    <span className="toggle-icon ms-auto"></span>
                  </button>
                </h2>
                <div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionCourses">
                  <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                      <li>What is Angular</li>
                      <li>Angular Installation</li>
                      <li>Create an Angular project</li>
                      <li>Angular File Structure & First App</li>
                      <li>Angular Architecture</li>
                      <li>Interpolation In Angular</li>
                      <li>Angular Components Functions, Events</li>
                      <li>Angular databinding</li>
                      <li>Angular with Bootstrap</li>
                      <li>Angular Forms with validation</li>
                      <li>Routing, Optional route parameters and Navigation</li>
                      <li>Angular pipes</li>
                      <li>Angular directives</li>
                      <li>Services API Call</li>
                      <li>HTTP and observables</li>
                      <li>Dependancy injection</li>
                      <li>Angular App & REST API Connectivity</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* collapseSeven */}
              <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="headingSeven">
                  <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button"
                    data-bs-toggle="collapse" data-bs-target="#collapseSeven"
                    aria-expanded="false" aria-controls="collapseSeven">
                    React JS
                    <span className="toggle-icon ms-auto"></span>
                  </button>
                </h2>
                <div id="collapseSeven" className="accordion-collapse collapse" aria-labelledby="headingSeven" data-bs-parent="#accordionCourses">
                  <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                      <li>Introduction, History, Features</li>
                      <li>Installation - React environment, First React App</li>
                      <li>React ES6, JSX, Components</li>
                      <li>Angular Vs React Difference</li>
                      <li>Ways to rendering HTML</li>
                      <li>Functional Vs Class Components</li>
                      <li>Props, State, methods, Hooks - useState, useEffect, useContext, useRef, useReducer, useCallback, etc.</li>
                      <li>Event Handling, Forms, Conditional Rendering</li>
                      <li>Styling - CSS, CSS Modules, CSS-in-JS</li>
                      <li>React Router - Setup, routes, parameters</li>
                      <li>Async/await, Promises, API.</li>
                      <li>Axios package, CRUD Operation using Axios.</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* collapseEight */}
              <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="headingEight">
                  <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button"
                    data-bs-toggle="collapse" data-bs-target="#collapseEight"
                    aria-expanded="false" aria-controls="collapseEight">
                    Industrial Tools
                    <span className="toggle-icon ms-auto"></span>
                  </button>
                </h2>
                <div id="collapseEight" className="accordion-collapse collapse" aria-labelledby="headingEight" data-bs-parent="#accordionCourses">
                  <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Git</strong>:
                    <ul>
                      <li>Version Control •Git Introduction</li>
                      <li>Git Installation</li>
                      <li>Create and Clone Repository</li>
                      <li>Commonly used commands in Git</li>
                      <li>Working with Remote Repository</li>
                      <li>Branching and merging in Git</li>
                      <li>Merge Conflicts</li>
                      <li>Stashing, Rebasing, Reverting and Resetting</li>
                      <li>Git Workflows</li>
                    </ul>

                    <strong>Jenkins</strong>:
                    <ul>
                      <li>Introduction to Continuous</li>
                      <li>Integration</li>
                      <li>Jenkins Architecture</li>
                      <li>Plugin Management in Jenkins</li>
                      <li>Jenkins Security Management</li>
                      <li>Notification in Jenkins</li>
                      <li>Jenkins Master-slave architecture</li>
                      <li>Jenkins Delivery Pipeline</li>
                      <li>Jenkins Declarative Pipeline</li>
                      <li>CI/CD Pipeline</li>
                      <li>Integrate Git with Jenkins</li>
                      <li>Integrate Maven with Jenkins</li>
                    </ul>

                    <strong>Jira</strong>:
                    <ul>
                      <li>Introduction to JIRA</li>
                      <li>Installation</li>
                      <li>Create project, Scheme, Issues</li>
                      <li>Add Users</li>
                      <li>Jira Dashboard and Gadgets</li>
                      <li>Kanban Boards and Scrum</li>
                      <li>Write Test Cases, Test Cycles</li>
                      <li>Defect / Bug Templates</li>
                      <li>Logging defects</li>
                      <li>Defect Lifecycle</li>
                      <li>Searching Defects and doing bulk Changes</li>
                      <li>Search Filters</li>
                      <li>Advanced Search using JQL</li>
                      <li>Jira Query Language</li>
                      <li>Generating Reports</li>
                      <li>Types of Reports</li>
                      <li>Backlog</li>
                      <li>Agile Project Monitoring and reporting with Jira</li>
                    </ul>

                    <strong>Maven</strong>:
                    <ul>
                      <li>Introduction to Maven</li>
                      <li>Maven Architecture</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* collapseNine */}
              <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="headingNine">
                  <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button"
                    data-bs-toggle="collapse" data-bs-target="#collapseNine"
                    aria-expanded="false" aria-controls="collapseNine">
                    Software Project Management (SPM)
                    <span className="toggle-icon ms-auto"></span>
                  </button>
                </h2>
                <div id="collapseNine" className="accordion-collapse collapse" aria-labelledby="headingNine" data-bs-parent="#accordionCourses">
                  <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                      <li>Introduction to Project Management</li>
                      <li>Scope of Project</li>
                      <li>Project Scheduling</li>
                      <li>Team Responsibilities and Activities</li>
                      <li>Test Cases and Cost Implications</li>
                      <li>UATS (User Acceptance Testing)</li>
                      <li>SDLC (Software Develpoment Life Cycle)</li>
                    </ul>
                  </div>
                </div>
              </div>

            </div>


        </div>
        <div className='col-md-4 text-start mt-4 myfont1'>
          <h2 className='text-center mt-2 mb-4 fw-bold'>Training Features</h2>
          <div className="card mb-2">
            <div className="card-body">
              <p className="card-text lead"><strong>
                <ul>
                  <li>Expert Faculty</li>
                  <li>Hands-on Projects</li>
                  <li>Placement Assistance</li>
                  <li>Interactive Sessions</li>
                  <li>Doubt Clearing Sessions</li>
                  <li>Soft Skills Training</li>
                </ul>
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>


    {/* Free Interview Assessment */}
    <div className="container-fluid text-center bg-primary text-white p-4 myfont1">
      <h2 className='fw-bold'>Free Interview Assessment</h2><br></br>
          <button
            type="button"
            className="btn btn-outline-light bg-light px-4 py-2 text-dark fw-semibold shadow-sm"
            data-bs-toggle="modal"
            data-bs-target="#whatsappModal"
          >
            Click Here To Download
          </button>

        <div class="modal fade" id="whatsappModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-sm">
            <div class="modal-content">
              {/* <div class="modal-header">
                <h1 class="modal-title fs-5" id="exampleModalLabel">Modal title</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div> */}
              <div class="modal-body">
                <strong>Verify your WhatsApp Number <span className='text-danger'>*</span></strong><br></br><br></br>
                <input type='number' placeholder='Enter WhatsApp Number' className='form-control rounded-0'/>
              </div>
              <div class="modal-footer d-flex justify-content-center">
                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={handleDownload}>Close</button>
                  <button className="btn btn-primary" data-bs-target="#exampleModalgetotp" data-bs-toggle="modal">Get OTP</button>
              </div>
            </div>
          </div>
        </div>

        {/* otp modal */}

        <div class="modal fade" id="exampleModalgetotp" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-sm">
            <div class="modal-content">
              <div class="modal-body">
                <input type='number' placeholder='Enter OTP Here' className='form-control rounded-0'/>
              </div>
              <div class="modal-footer d-flex justify-content-center">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button className="btn btn-primary">Download</button>
              </div>
            </div>
          </div>
        </div>
    </div>  

    {/* frequently asked questions */}
    <Faq/>


    {/* Our Partners */}
    <Logoslider/>


    {/* https://www.cetpainfotech.com/technology/full-stack-developer-course-with-java */}

      <Footer/>
      <FloatingButton />
      <Mobilefooterbtn />
      </div>
  )
}

export default Java